import React, { useState } from "react";
import RequestService from "../../../services/request.service";

// import AuthService from "../../../features/auth/auth.service";

import { Button, Modal } from 'react-bootstrap'

import Dialog from '../../../services/Dialogs'


import { toast } from 'react-toastify'



import * as XLSX from 'xlsx';


const ModalCargaMasiva = (props) => {


    // const currentUser  = AuthService.getCurrentUser();


  const dialog = new Dialog()

  const { showModalCarga, handleCloseModalCarga } = props


  const [ archivo_subir, setArchivoSubir ] = useState<any>([])

const handleUpload = (e) => {
    e.preventDefault();

    var files = e.target.files, f = files[0];
    var reader = new FileReader();
    reader.onload = function (e:any) {
        var data : any = e.target.result;
        let readedData = XLSX.read(data, {type: 'binary'});
        const wsname = readedData.SheetNames[0];
        const ws = readedData.Sheets[wsname];

        /* Convert array to json*/
        const dataParse = XLSX.utils.sheet_to_json(ws, {header:1});
        setArchivoSubir(dataParse);
    };
    reader.readAsBinaryString(f)
    return false
}


  const [ archivo_evidencia, setArchivoEvidenciaSubir ] = useState<any>([])

const handleUploadEvidencia = (e: React.ChangeEvent<HTMLInputElement>) => {
  e.preventDefault();

  // files es un FileList
  const files = e.target.files;
  if (!files || files.length === 0) return;

  const file = files[0]; // primer archivo
  const reader = new FileReader();
  
  reader.readAsDataURL(file);
  reader.onload = (e: any) => {
    setArchivoEvidenciaSubir(e.target.result.split(',')[1]);
  };
};


const enviarVerificacionMasiva = async(e) => {

  try{

  await dialog.open({
    accept: 'Si',
    cancel : "No",
    dialogClass: '',
    message: 'Un momento',
    // soundAccept: 'https://assets.stoumann.dk/audio/accept.mp3',
    // soundOpen: 'https://assets.stoumann.dk/audio/open.mp3',
    target: e.target,
    template: `<p>¿Toda la información es correcta?</p>`
  })
  let dialogo : any = await dialog.waitForUser()

  if (dialogo) {
    
    let res = await RequestService.create('aseguramiento/carga_masiva', { tramites_masivo : archivo_subir, archivo_evidencia : archivo_evidencia })
    if(res.data){
      if(res.data.errores.length > 0){
        for (var i = 0; i < res.data.errores.length; ++i) {
          toast.warning('El UUID '+res.data.errores[i][0]+' no se logro asegurar. Verifique su información.')
        }
      }
      handleCloseModalCarga()
      toast.success('La Carga Masiva se realizo correctamente')
    }
    else{
      toast.error('Error al migrar la informacion')
    }
    
  }




  }
  catch(e){
    toast.error('Error al cargar la verificación masiva')
  }
}


  return (

      <React.Fragment>
        
              <Modal size={'lg'} show={showModalCarga} onHide={handleCloseModalCarga}>
                <Modal.Header closeButton>
                  <Modal.Title>Carga Masiva de Aseguramiento</Modal.Title>
                </Modal.Header>
                <Modal.Body>

  <div className="mb-3">
    <label htmlFor="archivo" className="form-label">Selecciona el Layout</label>
    <input type="file" className="form-control" onChange={handleUpload} accept=".xlsx" id="archivo" />
  </div>
                  

                    

                    {
                      // JSON.stringify(archivo_subir)
                    }

                    {

                      archivo_subir.length > 0 && (

                          <React.Fragment>


                              <table className="table table-sm">
                                <thead style={{fontSize:10}}>
                                  <tr>
                                    <th scope="col">KEY</th>
                                    <th scope="col">CURP</th>
                                    <th scope="col">Monto de Aseguramiento</th>
                                    <th scope="col">Sueldo de Aseguramiento</th>
                                    <th scope="col">Fecha de Alta</th>
                                    <th scope="col">Fecha de Baja</th>
                                    <th scope="col">Fecha de Aseguramiento</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {
                                    archivo_subir.map( (registro,index) =>

                                        <React.Fragment key={ Math.random().toString(36).substr(2, 9) }>
                                          
                                          {
                                            index > 0 && (

                                                <tr key={ Math.random().toString(36).substr(2, 9) }>
                                                  <td width={80}>
                                                    <small style={{fontSize:6}}>{registro[0]}</small>
                                                  </td>
                                                  <td className="v">
                                                    <small>{registro[1]}</small>
                                                  </td>
                                                  <td className="v" width={100}>
                                                    <small>$ {parseFloat(registro[2]).toFixed(2)}</small>
                                                  </td>
                                                  <td className="v" width={100}>
                                                    <small><b>$ { (registro[2] * 1.0452).toFixed(2) } </b></small>
                                                  </td>
                                                  <td className="v" width={100}>
                                                    <small>{registro[3]}</small>
                                                  </td>
                                                  <td  className="v"width={100}>
                                                    <small>{registro[4]}</small>
                                                  </td>
                                                  <td className="v" width={100}>
                                                    <small>{registro[5]}</small>
                                                  </td>
                                                </tr>

                                            )
                                          }

                                        </React.Fragment>


                                    )
                                  }

                                </tbody>
                              </table>




  <div className="mb-3">
    <label htmlFor="evidencia" className="form-label">Selecciona el archivo de Evidencia</label>
    <input type="file" className="form-control" onChange={handleUploadEvidencia} accept=".pdf" id="evidencia" />
  </div>
           



                          </React.Fragment>

                      )


                    }


                </Modal.Body>
                <Modal.Footer>
                  <Button variant="danger" onClick={handleCloseModalCarga}>
                    Cancelar
                  </Button>

                    {

                      archivo_subir.length > 0 && (

                          <Button variant="success" onClick={enviarVerificacionMasiva}>
                            Reportar Aseguramiento
                          </Button>

                      )
                   }


                </Modal.Footer>
              </Modal>



      </React.Fragment>


    )



}


export default ModalCargaMasiva